import BaseMapper from '../../BaseMapper';

const EventRemoveMapper = (data, context) => {
    return data;
};

export default EventRemoveMapper;
